import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Form, InputNumber, message } from 'antd';
import NodeIdFields from '../Connections/NodeIdField';
import { useDispatch, useSelector } from 'react-redux';
import { createConnectionAction, getConnectionsAction } from '../../../../store/EditoreSlice';
import Input from '../../../../components/common/Input';
import Select from '../../../../components/common/Select';
import Switch from '../Switch';
const EscalatorForm = ({ updateStateData, formConnection, setSelelectNodeIndex }) => {
    // const [form] = Form.useForm<IEscalatorForm>();
    const dispatch = useDispatch();
    const form = formConnection;
    const type = Form.useWatch('type', form);
    const connectionId = Form.useWatch('nodeIds', form);
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    // useEffect(() => {
    //   form.setFieldsValue({
    //     nodeIds: type === 'ELEVATOR' ? ['', ''] : ['', ''],
    //   });
    // }, [type, form]);
    const onFinish = (values) => {
        values.siteId = siteId ? siteId : '';
        dispatch(createConnectionAction(values)).then((res) => {
            form.resetFields();
            if (res?.type === 'editor/createConnections/fulfilled' && siteId) {
                dispatch(getConnectionsAction(siteId));
                message.success('Connection added successfully');
            }
        });
    };
    const initialValues = {
        weight: 0,
        multiplier: 0,
        name: '',
        type: 'ESCALATOR',
        accessible: true,
        active: true,
        nodeIds: ['', ''],
        siteId: siteId ? siteId : '',
        direction: 'START_TO_END',
    };
    const connectionTypes = [
        { value: 'ESCALATOR', label: 'Escalator' },
        { value: 'ELEVATOR', label: 'Elevator' },
        { value: 'STAIRS', label: 'Stairs' },
        { value: 'PASSAGE', label: 'Passage' },
        { value: 'DOOR', label: 'Door' },
        { value: 'RAMP', label: 'Ramp' },
    ];
    const directionTypes = [
        { value: 'START_TO_END', label: 'Start to End' },
        { value: 'END_TO_START', label: 'End to Start' },
        { value: 'BOTH', label: 'Both' },
    ];
    // Filter direction types based on the selected connection type
    const filteredDirectionTypes = type === 'ELEVATOR' ? directionTypes?.filter((d) => d.value === 'BOTH') : directionTypes;
    React.useEffect(() => {
        if (type === 'ELEVATOR') {
            form.setFieldsValue({ direction: 'BOTH' });
        }
    }, [type, form]);
    return (_jsxs(Form, { form: formConnection, layout: "vertical", onFinish: onFinish, initialValues: initialValues, children: [_jsx(Form.Item, { name: "name", label: "Name", rules: [{ required: true, message: 'Please input the name!' }], children: _jsx(Input, { variant: "filled", placeholder: "Enter name" }) }), _jsx(Form.Item, { name: "type", label: "Type", rules: [{ required: true, message: 'Please select the type!' }], children: _jsx(Select, { variant: "filled", options: connectionTypes, allowClear: true, placeholder: "Connection Type" }) }), _jsx(Form.Item, { name: "direction", label: "Direction", rules: [{ required: true, message: 'Please select the direction!' }], children: _jsx(Select, { options: filteredDirectionTypes, variant: "filled", allowClear: true, placeholder: "Connection Direction" }) }), _jsx(Form.Item, { label: "Connect Nodes", tooltip: "This is a required field", name: 'nodeids', children: _jsx(NodeIdFields, { setSelectedNodeIndex: setSelelectNodeIndex, updateStateData: updateStateData, type: type }) }), _jsx(Form.Item, { name: "weight", label: "Weight", rules: [{ required: true, message: 'Please input the weight!' }], children: _jsx(InputNumber, { variant: "filled", min: 0, placeholder: "Enter weight", style: { width: '100%' } }) }), _jsx(Form.Item, { name: "multiplier", label: "Multiplier", rules: [{ required: true, message: 'Please input the multiplier!' }], children: _jsx(InputNumber, { variant: "filled", min: 0, placeholder: "Enter multiplier", style: { width: '100%' } }) }), _jsx(Form.Item, { name: "accessible", label: "Accessible", valuePropName: "checked", children: _jsx(Switch, { size: "small", label: 'is Accessible?' }) }), _jsx(Form.Item, { name: "active", label: "Active", valuePropName: "checked", children: _jsx(Switch, { size: "small", label: 'is Active?' }) })] }));
};
export default EscalatorForm;
